














import Component from "vue-class-component";
import { BaseRootPageComponent } from "../BaseRootPageComponent";

@Component
export default class Unauthorized extends BaseRootPageComponent {
  created() {
    this.setTitle("Unauthorized");
  }
}
